export default __webpack_public_path__ + "static/media/slider_arrow.68b5ae3f.svg";